import React, { useEffect, useState } from 'react'
import CheckBox from '../CheckBox/CheckBox'
import styles from './Proporties.module.css'
import { property } from '../../store/poperty'
import http from '../../Service/http'
import { student } from '../../store/student'
import { observer } from 'mobx-react-lite'
import BlueBtn from '../SidBarButtons/BlueBtn'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline } from 'react-icons/md'
import NotesModal from '../Modal/NodesModal'
import { getProperties, getPayment, getDescription, delDescription } from './../../Service/properties'
import { AiFillBell } from 'react-icons/ai'
import ConfirmModal from '../Modal/ConfirmModal'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { accept } from '../../store/accept'
import { useTranslation } from 'react-i18next'
import { auth } from '../../store/auth'

export const Proporties = observer(function () {
	const notify = title => toast(title)
	const { t } = useTranslation()
	const [modal, setModal] = useState({
		modal: false,
		id: 0
	})
	const [accessForm, setAccessForm] = useState({
		Buhgalteriy: false,
		KjMTB: false,
		biblioteka: false,
		ckb: false,
		dekanat: false,
		id_group: 10234,
		id_student: 173196,
		obshejitie: false,
		pole1: false,
		pole2: false,
		pole3: false
	})
	const [confirmModal, setConfirmModal] = useState({
		modal: false,
		idDesc: 0
	})
	const closeModalNotes = () => {
		setModal({
			modal: false,
			id: 0
		})
	}

	async function getDataProperty(id, idGr) {
		const properties = await getProperties(id, idGr)
		property.newProperties(properties)
		const payment = await getPayment(id)
		property.newPayment(payment)
		const desc = await getDescription(id)
		property.newDescription(desc)
		let obj = {}
		const r = properties?.map((item, i) => {
			obj = { ...obj, [item.okno_pole]: Boolean(item.dolg) }
		})
		setAccessForm({ ...obj, AVN_user: auth.user.data.id, id_student: student.student.id_student, id_group: student.student.id_group })
		property.newTempVar({
			...obj,
			AVN_user: auth.user.data.id,
			id_student: student.student.id_student,
			id_group: student.student.id_group
		})
	}

	const delDesc = async () => {
		const res = await delDescription(confirmModal.idDesc)
		if (res) {
			const oknoDesc = await getDescription(student.student.id_student)
			await property.newDescription(oknoDesc)
			closeConfirmModal()
			notify('Примечание удалено!')
		}
	}

	const closeConfirmModal = () => {
		setConfirmModal({ modal: false, idDesc: 0 })
	}

	useEffect(() => {
		if (student.student.id_student && student.student.id_group) {
			getDataProperty(student.student.id_student, student.student.id_group)
		}
	}, [student.student.id_student, student.student.id_group])

	return (
		<div className={styles.Dolgi}>
			<NotesModal close={closeModalNotes} modal={modal.modal} id={modal.id} />
			<ConfirmModal title={t('st:other.confirm')} isOpen={confirmModal.modal} hundleTrue={delDesc} setIsOpen={closeConfirmModal} />
			<h3 className={styles.title}>{t('st:other.dolg')}</h3>
			<div className={styles.checkboxs}>
				{property.properties?.map((item, i) => {
					if (accept.oknoPropList[i].visibility) {
						return (
							<div
								className={styles.checkbox}
								key={item.id_okno_properties}
								style={{ opacity: !!property.accessProperty[i]?.visibles ? 1 : 0.6 }}
							>
								<CheckBox
									item={accessForm}
									dsbl={!property.accessProperty[i]?.visibles}
									onchange={e => {
										setAccessForm(state => {
											return { ...state, [item.okno_pole]: e }
										})
									}}
									checked={accessForm[item.okno_pole]}
									name={accessForm[item.okno_pole]}
									active={true}
								/>
								<label className={styles.label}>{item.okno_title}</label>
							</div>
						)
					}
				})}
			</div>
			<div className={styles.btns}>
				<BlueBtn
					dsbl={!student.student.id_student}
					title={t('st:other.notes')}
					onclick={() => {
						setModal({
							modal: true,
							id: 0
						})
					}}
				>
					<AiFillBell />
				</BlueBtn>
				{JSON.stringify(property.tempVar) != JSON.stringify(accessForm) ? (
					<BlueBtn
						dsbl={false}
						title={t('st:button.save')}
						onclick={async () => {
							const res = await http.post('/propertiesiu', { ...accessForm, id_student: student.student.id_student })
							if (res.data) {
								const properties = await getProperties(student.student.id_student, student.student.id_group)
								property.newProperties(properties)
								notify(t('st:other.saved'))
							}
						}}
					>
						<AiFillBell />
					</BlueBtn>
				) : (
					''
				)}
			</div>
			<div className={styles.Descriptions}>
				<div className={styles.Descriptions_dolg}>
					{property.payment
						.filter(item => item.dolg)
						.map((item, i) => {
							return (
								<div className={styles.Description_item} key={item.come_date}>
									<p>{++i} &nbsp; Долги за обучение:</p>

									<div>
										<b className={styles.dolg_count}>{item.p22 + ': ' + item.dolg + 'сом;'}</b>
									</div>
								</div>
							)
						})}
					{property.description.map((item, i) => {
						return (
							<div className={styles.Description_item} key={item.id_okno_description}>
								<p>
									Примечание: &nbsp;
									{item.okno_description}
									<FiEdit
										className={styles.descEditBtn}
										onClick={() => {
											setModal({
												modal: true,
												id: item.id_okno_description
											})
										}}
									/>
									<MdDeleteOutline
										className={styles.descEditBtn}
										onClick={async () => {
											setConfirmModal({
												modal: true,
												idDesc: item.id_okno_description
											})
										}}
									/>
								</p>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
})
